import "@/App.css";
import { SmoothScroll } from "@/components/SmoothScroll";
import { ScheduleProvider } from "@/components/ScheduleModal";
import { Seo } from "@/components/Seo";
import { businessEntity } from "@/data/business";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Founder } from "@/components/Founder";
import { Products } from "@/components/Products";
import { HomeReviews } from "@/components/Reviews";
import { QuoteForm } from "@/components/QuoteForm";
import { Contact } from "@/components/Contact";
import { CareersInvite } from "@/components/CareersInvite";
import { Footer } from "@/components/Footer";

export default function Site() {
  return (
    <div className="App grain bg-[#030303]">
      <Seo
        title="John Campbell Insurance | Life Insurance Broker in Chandler, AZ"
        description="John Campbell Insurance helps families in Chandler, throughout Arizona, and in select states understand life insurance options through clear, relationship-first guidance."
        path="/"
        jsonLd={[businessEntity]}
      />
      <ScheduleProvider>
        <SmoothScroll>
          <Navbar />
          <main>
            <Hero />
            <Marquee />
            <Manifesto />
            <Founder />
            <Products />
            <HomeReviews />
            <QuoteForm />
            <Contact />
            <CareersInvite />
          </main>
          <Footer />
        </SmoothScroll>
      </ScheduleProvider>
    </div>
  );
}
